import React from "react";
import { CompanyNewsTileType } from "@irati/types";
import convertVideoUrlToEmbedUrl from "@irati/homepage/helpers/convertVideoUrlToEmbedUrl";
import { StyledImage, StyledImageTile, StyledContentWrapper, StyledVideo, StyledLink } from "./styled";
import Message from "./Message";
var VideoTile = function (_a) {
    var companyNewsTile = _a.companyNewsTile;
    var _b = companyNewsTile.config, imageUrl = _b.imageUrl, message = _b.message, type = _b.type, videoUrl = _b.videoUrl;
    if (type !== CompanyNewsTileType.Video) {
        return null;
    }
    var videoOutput = convertVideoUrlToEmbedUrl(videoUrl);
    return (React.createElement(StyledImageTile, null,
        imageUrl && (React.createElement(StyledLink, { href: videoUrl, target: "_blank", rel: "noopener noreferrer" },
            React.createElement(StyledContentWrapper, null,
                React.createElement(StyledImage, { imageUrl: imageUrl })))),
        !imageUrl && videoOutput && videoOutput.url && (React.createElement(StyledContentWrapper, null,
            React.createElement(StyledVideo, null,
                React.createElement("iframe", { src: videoOutput.url, frameBorder: "0", allow: "accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture", allowFullScreen: true, title: message, style: {
                        position: "relative",
                        height: "100%",
                        width: "100%"
                    } })))),
        React.createElement(Message, { message: message })));
};
export default VideoTile;
